import {
	Box,
	CircularProgress,
	Typography,
} from "@mui/material"
import { useDispatch, useSelector } from "react-redux"
import {
	AUTOMATED_SEARCH_PANEL_VIEW,
	getAutomatedSearchList,
	selectAutomatedSearchPanelView,
	selectAutomatedSearchSelectedSearch,
	selectIsLoading,
	selectSearches,
} from "../../../reducers/automatedSearchViewSlice"
import { useEffect, useState } from "react"
import {AutomatedSearchForm} from "./AutomatedSearchForm"
import {AutomatedSearchArticles} from "./AutomatedSearchArticles"
import AutomatedSearchList from "./AutomatedSearchList"
import {useWorkspaceContext} from "../../../pages/Dashboard"

export function AutomatedSearchPanel() {
	const { workspaceId } = useWorkspaceContext()
	const view = useSelector((state) => selectAutomatedSearchPanelView(state, workspaceId))
	const selectedSearch = useSelector((state) => selectAutomatedSearchSelectedSearch(state, workspaceId))
	const dispatch = useDispatch()
	const [searchToUpdate, setSearchToUpdate] = useState(null)
	const searches = useSelector((state) => selectSearches(state, workspaceId))
	const isLoading = useSelector((state) => selectIsLoading(state, workspaceId))

	useEffect(() => {

		if (view === AUTOMATED_SEARCH_PANEL_VIEW.SEARCH_LIST) {
			setSearchToUpdate(null)
		}
	}, [view])

	const getSearches = () => {
		dispatch(getAutomatedSearchList({workspaceId}))
	}
	console.log(`AutomatedSearchPanel ${workspaceId}: isLoading=${isLoading}, view=${view}, selectedSearch=${selectedSearch?.id}`)
	if (isLoading) {
		return (
			<Box
				sx={{
					display: "flex",
					flexDirection: "column",
					justifyContent: "center",
					alignItems: "center",
					minHeight: "200px",
				}}
			>
				<CircularProgress />
				<Typography>
						One moment, we are loading your automated searches!
				</Typography>
			</Box>
		)
	} else if (view === AUTOMATED_SEARCH_PANEL_VIEW.SEARCH_LIST) {
		return (
			<AutomatedSearchList
				searches={searches}
				getSearches={getSearches}
				setSearchToUpdate={setSearchToUpdate}
			/>
		)
	} else if (view === AUTOMATED_SEARCH_PANEL_VIEW.AUTOMATED_SEARCH_FORM) {
		return (
			<AutomatedSearchForm
				searchToUpdate={searchToUpdate}
				setSearchToUpdate={setSearchToUpdate}
				getSearches={getSearches}
			/>
		)
	} else if (
		view === AUTOMATED_SEARCH_PANEL_VIEW.ARTICLE_LIST &&
		selectedSearch
	) {
		return (
			<AutomatedSearchArticles selectedSearch={selectedSearch}/>
		)
	}
}